import { useDefaultRedirect } from "@/hooks/use-default-redirect";
import { PendingExperimentActivation } from "@/routes/experiments/ExperimentsActivationPage";
import { parseAsBoolean, parseAsString, useQueryState } from "nuqs";
import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

export const SlashRedirect: FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { state } = useLocation();
    const to = useDefaultRedirect();
    const [autoStart] = useQueryState("autostart", parseAsBoolean.withDefault(false));
    const [promptParam] = useQueryState("p", parseAsString);

    if (!to) {
        return null;
    }

    // When 'p' parameter is present, always redirect to /ai without showing create modal
    const shouldShowCreateModal = promptParam ? false : !!document.location.hash;

    return (
        <>
            <PendingExperimentActivation />
            <Navigate
                to={{ pathname: to, hash: document.location.hash, search: document.location.search }}
                replace
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            state={{ ...state, showCreateModal: shouldShowCreateModal, autoStart }}
            />
        </>
    );
};
